/**
 * Generates action types with namespaces
 */

export default namespace => type => `${namespace}/${type}`
